export default "__VITE_ASSET__e969219d__"